module.exports = __webpack_public_path__ + "img/tongzhuang.001fb324.png";